import React, { useState, } from 'react';
import { toast } from 'react-toastify';
import { multiFactor, TotpMultiFactorGenerator, } from 'firebase/auth';

import firebase from '../firebase';
import ProgressButton from './ProgressButton';
import MultiFactorEnrollModal from './modals/MultiFactorEnrollModal';

const auth = firebase.auth();
const issuer = 'freee連結会計';

export const handleMultiFactorError = async (e) => {
  if(e.code === 'auth/requires-recent-login') {
    if(!window.confirm('セキュリティのため再ログインが必要です。ログアウトしてよろしいですか？')) return;

    await auth.signOut();
    return;
  }

  console.error(e);
  const message = ({
    'auth/invalid-verification-code': '認証コードが正しくありません',
    'auth/unverified-email': 'メールアドレスの認証が完了していません',
  })[e.code] || '失敗しました';
  toast.error(message);
};

export default function MultiFactorEnrollButton(props) {
  const { firebaseUser, onEnrolled = _ => _, label = '設定する', ...extraProps } = props;
  const [enrollment, setEnrollment] = useState(null);
  const onClickEnroll = async () => {
    try {
      const session = await multiFactor(firebaseUser).getSession();
      const totpSecret = await TotpMultiFactorGenerator.generateSecret(session);
      setEnrollment({ totpSecret, totpUri: totpSecret.generateQrCodeUrl(firebaseUser.email, issuer), });
    } catch(e) {
      await handleMultiFactorError(e);
    }
  };
  const onSubmitVerificationCode = async ({ verificationCode }) => {
    try {
      const assertion = TotpMultiFactorGenerator.assertionForEnrollment(enrollment.totpSecret, verificationCode);
      await multiFactor(firebaseUser).enroll(assertion, 'Authenticator');
      setEnrollment(null);
      toast.success('2段階認証を設定しました');
      onEnrolled();
    } catch(e) {
      await handleMultiFactorError(e);
    }
  };

  return (
    <>
      <ProgressButton color="primary" process={onClickEnroll} {...extraProps}>{label}</ProgressButton>
      {
        enrollment != null && (
          <MultiFactorEnrollModal
            isOpen
            {...enrollment}
            issuer={issuer}
            accountName={firebaseUser.email}
            onSubmit={onSubmitVerificationCode}
            onClickClose={() => setEnrollment(null)}
          />
        )
      }
    </>
  );
};
